import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { INSTALL_ADMIN } from '../../../config/app_config';
import { checkCPAdmin, storeWithExpiration } from '../../../utils/common';
import { openDialog, closeDialog } from '../../../actions/dialog';
import {
  deleteInstallUser,
  getInstallationUsers,
  getInstalls,
  inviteInstallUser,
  updateInstallUser,
} from '../../../actions/customerPortal';

import Documents from './Documents';
import ConfigureInstall from './ConfigureInstall';
import ManageUsers from './ManageUsers';
import InstanceFieldsContainer from './InstanceFieldsContainer';
import InstallListItem from '../InstallListItem';

export class AdminIndex extends React.Component {
  static propTypes = {
    account: PropTypes.object.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    deleteInstallUserAction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    getInstallationUsersAction: PropTypes.func.isRequired,
    getInstallsAction: PropTypes.func.isRequired,
    installations: PropTypes.object.isRequired,
    installUsers: PropTypes.object,
    inviteUserAction: PropTypes.func,
    openDialogAction: PropTypes.func.isRequired,
    params: PropTypes.object.isRequired,
    updateInstallUserAction: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
  };

  static defaultProps = {
    installUsers: null,
    inviteUserAction: null,
  };

  componentWillMount = () => {
    const { getInstallsAction } = this.props;
    const token = storeWithExpiration.get('token');

    getInstallsAction(token);
  };

  renderAdminInstances = install => {
    const { installation } = install;
    const installId = installation.get('id');
    return <InstallListItem key={installId} install={install} />;
  };

  render() {
    const {
      account,
      closeDialogAction,
      deleteInstallUserAction,
      dialog,
      getInstallationUsersAction,
      installations,
      installUsers,
      inviteUserAction,
      openDialogAction,
      params,
      updateInstallUserAction,
      user,
    } = this.props;
    const page = params.page === 'home' ? 'admin-list' : params.page;
    let installObj = null;
    if (
      (page === 'configure-install' || page === 'manage-users' || page === 'instance-fields') &&
      params.instanceId &&
      installations &&
      installations.size > 0
    ) {
      const instanceId = parseInt(params.instanceId, 10);
      installObj = installations
        .filter(install => install.installation.get('id') === instanceId)
        .first();
    }
    const adminInstalls = installations
      .valueSeq()
      .filter(install => install.installationUser.get('permissions') === INSTALL_ADMIN);
    const installId = params.instanceId;
    const isCustomerAdmin = checkCPAdmin(installations);
    // const isCustomerPortal = checkCPUser(userTypeId);
    const whiteLabelCompany = account.get('companyName');

    return (
      <div className={isCustomerAdmin ? 'with-sidebar' : ''}>
        {isCustomerAdmin ? (
          <div>
            <div className="modal-wrap">
              {page === 'admin-list' ? (
                <div>
                  <div className="row row-top">
                    <div className="col-xs-12">
                      <h1>Admin Instances</h1>
                    </div>
                  </div>
                  {adminInstalls.valueSeq().map(this.renderAdminInstances)}
                </div>
              ) : null}
              {page === 'configure-install' && installObj ? (
                <ConfigureInstall
                  data={installObj}
                  escapeForm={this.escapeForm}
                  previousPageFunction={() => this.previousPage(page)}
                  submitFunction={() => this.nextPage(page)}
                  whiteLabelCompany={whiteLabelCompany}
                />
              ) : null}
              {page === 'manage-users' && installId && installObj ? (
                <ManageUsers
                  currentUser={user}
                  data={installObj}
                  installId={installId}
                  deleteInstallUserFunction={deleteInstallUserAction}
                  dialog={dialog}
                  getInstallationUsersFunction={getInstallationUsersAction}
                  setStatusFunction={updateInstallUserAction}
                  installUsers={installUsers}
                  inviteUserFunction={inviteUserAction}
                  closeDialogFunction={closeDialogAction}
                  openDialogFunction={openDialogAction}
                />
              ) : null}
              {page === 'instance-fields' && installId && installObj ? (
                <InstanceFieldsContainer data={installObj} />
              ) : null}
              {page === 'documents' ? <Documents /> : null}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { account, authentication, dialog, error, success, user, customerPortalData } = state;
  const installations = customerPortalData.get('installations') || null;
  const installUsers = customerPortalData.get('installUsers');
  return {
    account,
    authentication,
    dialog,
    error,
    installations,
    installUsers,
    success,
    user,
  };
}

export default connect(mapStateToProps, {
  closeDialogAction: closeDialog,
  deleteInstallUserAction: deleteInstallUser,
  getInstallationUsersAction: getInstallationUsers,
  getInstallsAction: getInstalls,
  inviteUserAction: inviteInstallUser,
  openDialogAction: openDialog,
  updateInstallUserAction: updateInstallUser,
})(AdminIndex);
